/**
 * Legacy response-component connection card.
 *
 * It intentionally has no connect action. New integration requests render the
 * provider-backed `integration_access_request` card, which creates an OAuth
 * link server-side and verifies the connection before showing success.
 */
export function useAppConnectionCardModel({
  title,
  status,
}) {
  const safeTitle = String(title ?? '').trim() || 'App'
  const showConnectedChrome = status === 'connected'
  const statusLabel = status === 'error' ? 'Error' : showConnectedChrome ? 'Connected' : 'Connection required'
  const chipColor = status === 'error' ? 'error' : showConnectedChrome ? 'success' : 'default'

  return {
    safeTitle,
    showConnectedChrome,
    statusLabel,
    chipColor,
  }
}
